import React from 'react';
import Maintenance from '../../../assets/images/Maintenance.png';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

const MaintainanceNotification = ({ heading, updateDate, message, data }) => {
  const [open, setOpen] = React.useState(true);
  return (
    open &&
    data && (
      <div className="maintenance-card d-flex align-items-center mb-4 overflow-hidden position-relative flex-column flex-sm-row">
        <img src={Maintenance} className="flex-shrink-0 me-4" alt="Maintenance" />
        <div>
          <h4>{heading}</h4>
          <p className="mb-2">{updateDate}</p>
          <p className="mb-3">{message}</p>
          {/* <button className="btn btn-castleRed">View Note</button> */}
        </div>
        <div className="close-btn position-absolute top-0 end-0 m-4">
          <FontAwesomeIcon onClick={() => setOpen(!open)} size="5px" icon={faXmark} />
        </div>
      </div>
    )
  );
};

MaintainanceNotification.propTypes = {
  heading: PropTypes.string,
  updateDate: PropTypes.string,
  message: PropTypes.string,
  data: PropTypes.object
};

export default MaintainanceNotification;
